import ConstData from "../../ConstData";

import { ctRcvKind, enTokenCMD } from "../../classTalk/CodeEnum";

import {
    getRcvKind,
    getMyHandsUpSendKey,
    getRcvWhisperChat,
    getMyUserSeq,
    sendJsonData
} from "../../RabbitmqClient";

import {
    checkDownloadableUrl
} from "../../func/ExportFunction";

// 20261015 대용량 데이터 RangeError 방지를 위한 base64 변환 헬퍼
import { bytesToBase64 } from "../../classTalk/EncodeDecode";

const normalizeBoolean = (value, defaultValue = false) => {
    if (typeof value === "boolean") return value;
    if (typeof value === "string") {
        const normalized = value.toLowerCase();
        if (normalized === "y" || normalized === "yes" || normalized === "true" || normalized === "1") return true;
        if (normalized === "n" || normalized === "no" || normalized === "false" || normalized === "0") return false;
    }

    return defaultValue;
};

const convertHttpsDownloadUrlForPbl = (downloadUrl) => {
    try {
        const urlInfo = new URL(downloadUrl);
        if (urlInfo.protocol !== "https:") return downloadUrl;

        return `http://${urlInfo.hostname}:8080${urlInfo.pathname}${urlInfo.search}${urlInfo.hash}`;
    } catch (err) {
        console.log("convertHttpsDownloadUrlForPbl - invalid url => ", downloadUrl, err);
        return downloadUrl;
    }
};

const sendIntensiveControlContentAck = (kind, contentInfo) => {
    if (!contentInfo || contentInfo.contentSeq === undefined || contentInfo.contentSeq === null || contentInfo.contentSeq === "") return;

    const {
        contentType,
        contentSeq,
        refContentSeq,
        userSeq,
        status,
    } = contentInfo;

    const ackData = {
        kind: "live",
        action: kind,
        information: {
            kind: "content-send-ack",
            contentType,
            contentSeq,
            refContentSeq,
            userSeq,
            status,
        }
    };

    console.log("sendIntensiveControlContentAck - ackData => ", ackData);
    sendJsonData(ackData, "");
}

/**
 * Pentalk Pro에서 받은 RBMQ 메시지 데이터를
 * Pentalk WiFi의 UI로 보여줘야 하는 경우
 * WiFi 형식에 맞게 변환을 돕는 Helper 메서드
 * 
 * @param {Object} dataObject - 디코딩된 데이터 객체
 * @param {String} routingKey - 라우팅 키
 * @#param {String} rawData - Raw(원시) 레벨 데이터
 * @since 2025-07-10.
 */
export const rcvRawDataWithRoutingKeyHelper = (/* rawData,  */dataObject, routingKey) => {
    console.log("rcvRawDataWithRoutingKeyHelper - routingKey => ", routingKey);
    console.log("dataObject => ", dataObject);
    // console.log("rawData => ", rawData);

    // const dataObject = decodingPacket(rawData);
    // console.log("rcvRawDataWithRoutingKeyHelper - dataObject => ", dataObject);

    if (dataObject === undefined || dataObject === null) return;

    switch (dataObject.CMD) {
        case enTokenCMD.NULL:
            break;

        case enTokenCMD.Ink_SDn:
        case enTokenCMD.Ink_SM: // decode 1point
        case enTokenCMD.Ink_SDM: // decode 2point
        case enTokenCMD.Ink_SUp: // decode 1point
        case enTokenCMD.Ink_DDn:
        case enTokenCMD.Ink_DM:
        case enTokenCMD.Ink_DDM:
        case enTokenCMD.Ink_DUp:
        case enTokenCMD.Ink_Erase1: // decode 2point
        case enTokenCMD.Ink_SingleStroke:
        case enTokenCMD.Ink_PageStroke:
        case enTokenCMD.Ink_Clear: // decode command
        case enTokenCMD.Ink_DefaultAttr:
        case enTokenCMD.Ink_Mode: // decode 1byte
        case enTokenCMD.Ink_Color: // decode 3byte
        case enTokenCMD.Ink_Tip: // decode 2double
        case enTokenCMD.rq_PageClear:
        case enTokenCMD.page_PutArtifact:
        case enTokenCMD.cont_PageJpeg:
        case enTokenCMD.cont_StudentPageJpeg:
        case enTokenCMD.ctl_PageInfo:
            rcvTokenDataHelper(dataObject.dataBuffer);
            break;

        /* case enTokenCMD.page_PutArtifact:
        case enTokenCMD.cont_PageJpeg:
        case enTokenCMD.cont_StudentPageJpeg:
            rcvCmd_PagePutHelper(dataObject.data, routingKey);
            break; */

        case enTokenCMD.chat_Text:
            _rcvChatTextHelper(dataObject.text, dataObject.name, routingKey);
            break;

        case enTokenCMD.chat_Voice:
            rcvChatVoiceMemoHelper(dataObject.data, dataObject.name, routingKey);
            break;

        case enTokenCMD.chat_Memo:
            rcvChatInkMemoHelper(dataObject.data, dataObject.name, routingKey);
            break;

        /* case enTokenCMD.ctl_PageInfo:
            // chatPageScrollOffset(dataObject.data);
            break; */

        case enTokenCMD.ct_UserLoginInfo:
            rcvUserStatusHelper(dataObject.INT1, dataObject.INT2, dataObject.BYTE1, routingKey);
            break;

        case enTokenCMD.ct_UploadAndShareFiles:
            _rcvChatFileShareHelper(dataObject.FileName, dataObject.name, routingKey);
            break;

        case enTokenCMD.ct_SendToWebJSonInfo:
            const obj = JSON.parse(dataObject.text);

            if (obj.kind !== undefined && obj.kind !== null && obj.information !== undefined && obj.information !== null) {
                rcvJsonDataHelper(obj, dataObject.name, routingKey);
            }/*  else {
                rcvJsonMessageHelper(obj);
            } */
            break;

        case enTokenCMD.ct_UpdateHandsUpImage:
            break;

        default:
            console.log(`rcvRawDataWithRoutingKeyHelper default case ... CMD[${dataObject.CMD}]`, dataObject);
            break;
    }
}

const rcvIntensiveControlHelper = (dataObject, userNickname, routingKey) => {
    const { kind, action, information } = dataObject;
    console.log(`rcvIntensiveControlHelper - kind[${kind}] action[${action}] information => `, information);

    if (action === "file-preparing") {
        // 20260901 추가: PBL 믹스드 학생은 URL 컨텐츠가 준비되기 전에 WPF 컨텐츠 영역에 준비 오버레이를 표시한다.
        sendToBrowserData("sendJson", JSON.stringify({
            ...information,
            action: kind,
            kind: action
        }), "");
    } else if (action === "file-upload") {
        const { uploadedPath, fileTransferType = "file-transfer", isAutoDownloadAllowed = false, isOverwriteAllowed = false, executeYn = "N", userNickname: infoUserNickname, originalFileName, contentSeq, refContentSeq } = information;
        const finalIsAutoDownloadAllowed = executeYn === "Y" ? true : isAutoDownloadAllowed;
        const rcvUserNickname = infoUserNickname || userNickname;
        const userSeq = getMyUserSeq();
        const normalizedFileTransferType = executeYn === "Y" ? "file-transfer" : "file-share";

        sendToBrowserData("sendJson", JSON.stringify({
            ...information,
            isOverwriteAllowed: normalizeBoolean(isOverwriteAllowed, false),
            action: kind,
            kind: action
        }), "");

        _rcvChatFileShareHelper(
            uploadedPath,
            rcvUserNickname,
            routingKey,
            normalizedFileTransferType,
            finalIsAutoDownloadAllowed,
            originalFileName,
            contentSeq,
            isOverwriteAllowed
        );

        sendIntensiveControlContentAck(kind, {
            contentType: "file-upload",
            contentSeq,
            refContentSeq,
            userSeq,
            status: "received",
        });
    } else if (action === "message") {
        const { message, userNickname: infoUserNickname, contentSeq, refContentSeq } = information;
        const rcvUserNickname = infoUserNickname || userNickname;
        const userSeq = getMyUserSeq();

        _rcvChatTextHelper(message, rcvUserNickname, routingKey);

        sendIntensiveControlContentAck(kind, {
            contentType: "message",
            contentSeq,
            refContentSeq,
            userSeq,
            status: "executed",
        });
    } else if (action === "intensive-start" || action === "intensive-end") {
        sendToBrowserData("sendJson", JSON.stringify(dataObject), "");
    } else if (action === "url-list" || action === "url-start" || action === "app-start" || action === "switch-main-tab" || action === "close-sub-tab") {
        const { contentSeq, refContentSeq } = information;
        const userSeq = getMyUserSeq();

        sendToBrowserData("sendJson", JSON.stringify({
            ...information,
            action: kind,
            kind: action
        }), "");

        sendIntensiveControlContentAck(kind, {
            contentType: action,
            contentSeq,
            refContentSeq,
            userSeq,
            status: "received",
        });
    } else if (action === "power-off") {
        const userSeq = getMyUserSeq();

        sendIntensiveControlContentAck(kind, {
            contentType: "power-off",
            userSeq,
            status: "received",
        });

        // 20260916 received 메시지 전송 후 전달하도록 위치 조정
        sendToBrowserData("sendJson", JSON.stringify({
            ...information,
            action: kind,
            kind: action
        }), "");
    } else {
        sendToBrowserData("sendJson", JSON.stringify(dataObject), "");
    }
}

/**
 * Pentalk Pro에서 받은 RBMQ 메시지 데이터를
 * Pentalk WiFi에 텍스트 챗(textChat) 데이터로 전달해야 하는 경우
 * WiFi 형식에 맞게 변환을 돕는 Helper 메서드
 * 
 * @param {String} messageValue - 전달받은 텍스트 메시지
 * @param {String} userNickname - 전달받은 메시지를 보낸 사용자 닉네임
 * @param {String} routingKey - 라우팅 키
 */
const _rcvChatTextHelper = (messageValue, userNickname, routingKey) => {
    /* if (window.opener) {
        if (typeof window.opener.appendReceiveChatMessage === "function") {
            window.opener.appendReceiveChatMessage(messageValue, userNickname);
        } else {
            console.log("rcvChatTextHelper - window.opener.appendReceiveChatMessage is not a function!!!");
        }
    } else {
        console.log("rcvChatTextHelper - window.opener is => ", window.opener);
    } */

    const sendEvent = "txtChat";
    const sendData = JSON.stringify({ msg: messageValue, nick: userNickname, isWhisper: getRcvWhisperChat(routingKey) });

    sendToBrowserData("sendChatData", JSON.stringify({ event: sendEvent, data: sendData }), "");
}

// 외부에서 호출할 수 있도록 export
export const rcvChatTextHelper = _rcvChatTextHelper;

/**
 * Pentalk Pro에서 받은 RBMQ 메시지 데이터를
 * Pentalk WiFi에 잉크 메모 파일 데이터로 전달해야 하는 경우
 * WiFi 형식에 맞게 변환을 돕는 Helper 메서드
 * 
 * @param {ArrayBuffer} imgData 전달받은 잉크 메모 파일 데이터
 * @param {String} userNickname - message를 보낸 이의 userNickname
 * @param {String} routingKey - 라우팅 키
 */
const rcvChatInkMemoHelper = (imgData, userNickname, routingKey) => {
    /* if (window.opener) {
        if (typeof window.opener.appendReceiveInkMemoChatMessage === "function") {
            window.opener.appendReceiveInkMemoChatMessage(imgData, userNickname);
        } else {
            console.log("rcvChatInkMemoHelper - window.opener.appendReceiveInkMemoChatMessage is not a function!!!");
        }
    } else {
        console.log("rcvChatInkMemoHelper - window.opener is => ", window.opener);
    } */
}

/**
 * Pentalk Pro에서 받은 RBMQ 메시지 데이터를
 * Pentalk WiFi에 보이스 메모 파일 데이터로 전달해야 하는 경우
 * WiFi 형식에 맞게 변환을 돕는 Helper 메서드
 * 
 * @param {ArrayBuffer} voiceData - 전달받은 보이스 메모 파일 데이터
 * @param {String} userNickname - 전달받은 메시지를 보낸 사용자 닉네임
 * @param {String} routingKey - 라우팅 키
 */
const rcvChatVoiceMemoHelper = (voiceData, userNickname, routingKey) => {
    /* if (window.opener) {
        if (typeof window.opener.appendReceiveVoiceMemoChatMessage === "function") {
            window.opener.appendReceiveVoiceMemoChatMessage(voiceData, userNickname);
        } else {
            console.log("rcvChatVoiceMemoHelper - window.opener.appendReceiveVoiceMemoChatMessage is not a function!!!");
        }
    } else {
        console.log("rcvChatVoiceMemoHelper - window.opener is => ", window.opener);
    } */
}

/**
 * Pentalk Pro에서 받은 RBMQ 메시지 데이터를
 * Pentalk WiFi에서 다운로드할 수 있는 파일 다운로드 URL로 변환하여 전달해야 하는 경우
 * WiFi 형식에 맞게 변환을 돕는 Helper 메서드
 * 
 * @param {String} pathData - 전달받은 파일 다운로드 URL
 * @param {String} userNickname - 전달받은 메시지를 보낸 사용자 닉네임
 * @param {String} routingKey - 전달받은 메시지를 수신한 bindKey
 * @param {String} [fileTransferType="file-transfer"] - 파일 전송/파일 공유 구분값. "file-transfer"는 다운로드 버튼 UI 표시, "file-share"는 다운로드 버튼 UI 미표시.
 * @param {Boolean|String} [isAutoDownloadAllowed=false] - 자동 다운로드 허용 여부. true/Y/yes/1이면 자동 다운로드 실행, false/N/no/0이면 자동 다운로드하지 않음.
 * @param {String} [originalFileName=""] - 전달받은 원본(사람이 읽을 수 있는) 파일 이름. C# 쪽에서 말풍선 표시용으로
 *  pblDownloadUrl 대신 사용할 수 있도록 sendData에 함께 실어 보냄 (2026-07-14 추가, 현재는 C# 쪽에서 주석 처리되어 미사용).
 * @param {Number} contentSeq - client_new_pbl에서 발급한 선생님 전송 콘텐츠 번호
 * @param {Boolean} [isOverwriteAllowed=false] - 동일 파일명 존재 시 덮어쓰기 허용 여부
 */
const _rcvChatFileShareHelper = (pathData, userNickname, routingKey, fileTransferType = "file-transfer", isAutoDownloadAllowed = false, originalFileName = "", contentSeq = null, isOverwriteAllowed = false) => {
    let selRcvKind = getRcvKind(routingKey, getMyHandsUpSendKey());
    if (selRcvKind !== ctRcvKind.Teacher) return;   // 20250813 ... Teacher가 보낸 파일 메시지인 경우에만 pbl 모드에서도 처리 ... by hjkim

    let url = "";
    if (!checkDownloadableUrl(pathData)) {
        console.log("/download/ 포함되지 않은 url임 ... pathData => ", pathData);
        url = ConstData.MAIN_HOST_ADD + ConstData.DOWNLOAD_DIR + pathData;
    } else {
        url = pathData;
    }
    const pblDownloadUrl = convertHttpsDownloadUrlForPbl(url);
    const allowOverwrite = normalizeBoolean(isOverwriteAllowed, false);
    console.log("rcvChatFileShareHelper - Final file download URL[", url, "], pblDownloadUrl[", pblDownloadUrl, "]");

    /* // 먼저 opener에 전달!
    if (window.opener) {
        if (typeof window.opener.rcvChatFileShareMessage === "function") {
            window.opener.rcvChatFileShareMessage(url, userNickname);
        } else {
            console.log("rcvChatFileShareHelper - window.opener.rcvChatFileShareMessage is not a function!!!");
        }
    } else {
        console.log("rcvChatFileShareHelper - window.opener is => ", window.opener);
    } */

    // c#에도 전달!
    const sendEvent = "download";
    const sendData = JSON.stringify({
        msg: url,
        pblDownloadUrl,
        nick: userNickname,
        isWhisper: getRcvWhisperChat(routingKey),
        fileTransferType,
        isAutoDownloadAllowed,
        isOverwriteAllowed: allowOverwrite,
        originalFileName,   // 20260714 추가: C# 쪽에서 말풍선 표시용으로 필요하면 pblDownloadUrl 대신 사용 가능 (현재 C# 쪽은 주석 처리되어 미사용)
        contentSeq
    });

    sendToBrowserData("sendFileData", JSON.stringify({ event: sendEvent, data: sendData }), "");
}

// 외부에서 호출할 수 있도록 export
export const rcvChatFileShareHelper = _rcvChatFileShareHelper;

/**
 * Pentalk Pro에서 받은 RBMQ 메시지 데이터를
 * Pentalk WiFi에 Token 데이터로 전달해야 하는 경우
 * WiFi 형식에 맞게 변환을 돕는 Helper 메서드
 * 
 * @param {ArrayBuffer} dataBuffer - Raw(원시) 레벨 데이터
 * @since 2025-07-14.
 */
const rcvTokenDataHelper = (dataBuffer) => {
    console.log("rcvTokenDataHelper - dataBuffer => ", dataBuffer);

    // const sendEvent = "token";
    // 20261015 대용량 데이터(페이지 이미지 등) RangeError 방지를 위해 청크 단위 base64 변환으로 교체
    // const sendData = window.btoa(String.fromCharCode.apply(null, dataBuffer));
    const sendData = bytesToBase64(dataBuffer);
    // const sendData = String.fromCharCode.apply(null, dataBuffer);

    /* // Uint8Array를 직접 Base64로 변환
    let binaryString = "";
    const bytes = new Uint8Array(dataBuffer);

    for (let i = 0; i < bytes.length; i++) {
        binaryString += String.fromCharCode(bytes[i]);
    }
    console.log("rcvTokenDataHelper - binaryString => ", binaryString);

    const sendData = window.btoa(binaryString); */
    console.log("rcvTokenDataHelper - sendData => ", sendData);

    // sendToBrowserData("sendRawData", JSON.stringify({ event: sendEvent, data: sendData }), "");
    // sendToBrowserData("sendRawData", sendData, "");
}

/**
 * 이미지 데이터 처리를 돕는 helper
 * 
 * @param {ArrayBuffer} imgData - 이미지 데이터
 * @param {String} routingKey - 전달받은 메시지를 수신한 bindKey
 * @since 2025-07-14.
 */
const rcvCmd_PagePutHelper = (imgData, routingKey) => {
    if (window.opener) {
        if (typeof window.opener.setDrawPage === "function") {
            window.opener.setDrawPage(imgData);
        } else {
            console.log("rcvCmd_PagePutHelper - window.opener.setDrawPage is not a function!!!");
        }
    } else {
        console.log("rcvCmd_PagePutHelper - window.opener is => ", window.opener);
    }
}

/**
 * RestApi or HandsUp 창 or Frontend 에서 온 데이터 처리를 돕는 helper
 * 
 * @param {Number} roomSeq - 전달받은 메시지를 보낸 이의 룸 시퀀스 번호
 * @param {Number} userSeq - 전달받은 메시지를 보낸 이의 사용자 시퀀스 번호
 * @param {Number} status - 전달받은 메시지를 보낸 이의 상태 값
 * @param {String} routingKey - 전달받은 메시지를 수신한 bindKey
 * @since 2025-07-14.
 */
const rcvUserStatusHelper = (roomSeq, userSeq, status, routingKey) => {
    console.log(`rcvUserStatusHelper - roomSeq[${roomSeq}], userSeq[${userSeq}], status[${status}], routingKey[${routingKey}]`);

    if (window.opener) {
        if (typeof window.opener.rcvUserStatus === "function") {
            window.opener.rcvUserStatus(status);
        } else {
            console.log("rcvUserStatusHelper - window.opener.rcvUserStatus is not a function!!!");
        }
    } else {
        console.log("rcvUserStatusHelper - window.opener is => ", window.opener);
    }

    /* switch (status) {
        case ConstCode.LIVE_OFF:
        case ConstCode.MIC_ON:
        case ConstCode.MIC_OFF:
        case ConstCode.DISABLE_MIC:
        case ConstCode.ENABLE_MIC:
            if (window.opener) {
                if (typeof window.opener.rcvUserStatus === "function") {
                    window.opener.rcvUserStatus(status);
                } else {
                    console.log("rcvUserStatusHelper - window.opener.rcvUserStatus is not a function!!!");
                }
            } else {
                console.log("rcvUserStatusHelper - window.opener is => ", window.opener);
            }
            break;

        default:
            console.log("default case - status => ", status);
            break;
    } */
}

/**
 * RestApi or HandsUp 창 or Frontend 에서 온 데이터 처리를 돕는 helper
 * 
 * @param {JSON} dataObject - JsonObject로 kind, action, information으로 구성됨
 * @param {String} userNickname - 전달받은 메시지를 보낸 이의 사용자 닉네임
 * @param {String} routingKey - 전달받은 메시지를 수신한 bindKey
 * @since 2025-07-14.
 */
const rcvJsonDataHelper = (dataObject, userNickname, routingKey) => {
    console.log(`rcvJsonDataHelper - userNickname[ ${userNickname} ], routingKey[ ${routingKey} ]`);
    console.log("dataObject => ", dataObject);

    if (dataObject.kind === undefined || dataObject.kind === null || dataObject.kind === "") return;
    if (dataObject.information === undefined || dataObject.information === null || dataObject.information === "") return;

    const { kind, action, information } = dataObject;

    if (kind === "user") {
        console.log(`rcvJsonDataHelper - kind[${kind}] action[${action}] information => `, information);

        let isNeedToPassData = false;

        if (action === "logout") {
            isNeedToPassData = true;
        } else if (action === "update") {
            isNeedToPassData = true;
        } else {
            console.log("rcvJsonDataHelper - action is else... ", action);
        }

        if (isNeedToPassData) {
            console.log("rcvJsonDataHelper - isNeedToPassData is true... Pass data.");

            if (window.opener) {
                if (typeof window.opener.rcvJsonData === "function") {
                    window.opener.rcvJsonData(dataObject);
                } else {
                    console.log("rcvJsonDataHelper - window.opener.rcvJsonData is not a function!!!");
                }
            } else {
                console.log("rcvJsonDataHelper - window.opener is => ", window.opener);
            }
        } else {
            console.log("rcvJsonDataHelper - isNeedToPassData is false... Do not pass data.");
        }
    } else if (kind === "live") {
        if (action === "chatting-lock") {
            if (information.isLiveChattingLocked !== undefined) {
                const { isLiveChattingLocked } = information;

                const sendEvent = "lock";
                const sendData = isLiveChattingLocked ? "lock_chat" : "unlock_chat";
                console.log("rcvJsonDataHelper - sendEvent[", sendEvent, "], sendData[", sendData, "]");

                sendToBrowserData("sendLockData", JSON.stringify({ event: sendEvent, data: sendData }), "");
            } else {
                console.log("rcvJsonDataHelper - isLiveChattingLocked is undefined...");
                console.log("information => ", information);
            }
        } else {
            console.log(`kind[${kind}] action[${action}] information => `, information);

            let isNeedToPassData = false;

            if (action === "live-on") { // 클래스 On
                isNeedToPassData = true;
            } else if (action === "edit-name") {
                isNeedToPassData = true;
            } else if (action === "add-member") {
                isNeedToPassData = true;
            } else if (action === "update-nickname") {
                isNeedToPassData = true;
            } else if (action === "logout") {
                isNeedToPassData = true;
            } else {
                console.log("rcvJsonDataHelper - action is else... ", action);
            }

            if (isNeedToPassData) {
                console.log("rcvJsonDataHelper - isNeedToPassData is true... Pass data.");

                if (window.opener) {
                    if (typeof window.opener.rcvJsonData === "function") {
                        window.opener.rcvJsonData(dataObject);
                    } else {
                        console.log("rcvJsonDataHelper - window.opener.rcvJsonData is not a function!!!");
                    }
                } else {
                    console.log("rcvJsonDataHelper - window.opener is => ", window.opener);
                }
            } else {
                console.log("rcvJsonDataHelper - isNeedToPassData is false... Do not pass data.");
            }
        }
    } else if (kind === "handsup") {
        console.log(`rcvJsonDataHelper - kind[${kind}] action[${action}] information => `, information);

        let isNeedToPassData = false;

        if (action === "initPAD") {
            isNeedToPassData = true;
        } else if (action === "p2pstart") {
            isNeedToPassData = true;
        } else if (action === "audioSelect") {
            isNeedToPassData = true;
        } else if (action === "pblStudentAudioListen") {
            // 20260928 오디오 관련 설정 변경: PBL 보조 창에서 받은 듣기 명령을 메인 학생 화면으로 전달한다.
            isNeedToPassData = true;
        } else if (action === "smallGroupStart") {
            isNeedToPassData = true;
        } else if (action === "smallGroupEnd") {
            isNeedToPassData = true;
        } else {
            console.log("rcvJsonDataHelper - action is else... ", action);
        }

        if (isNeedToPassData) {
            console.log("rcvJsonDataHelper - isNeedToPassData is true... Pass data.");

            if (window.opener) {
                if (typeof window.opener.rcvJsonData === "function") {
                    window.opener.rcvJsonData(dataObject);
                } else {
                    console.log("rcvJsonDataHelper - window.opener.rcvJsonData is not a function!!!");
                }
            } else {
                console.log("rcvJsonDataHelper - window.opener is => ", window.opener);
            }
        } else {
            console.log("rcvJsonDataHelper - isNeedToPassData is false... Do not pass data.");
        }
    } else if (kind === "android") {
        if (action === "ct_TouchScreenLock" || action === "ct_TouchScreenUnLock") {
            const sendEvent = "lock";
            const sendData = action === "ct_TouchScreenLock" ? "lock_touch" : "unlock_touch";
            console.log("rcvJsonDataHelper - sendEvent[", sendEvent, "], sendData[", sendData, "]");

            sendToBrowserData("sendLockData", JSON.stringify({ event: sendEvent, data: sendData }), "");
        } else {
            console.log("rcvJsonDataHelper - action is else... ", action);
        }
    } else if (kind === "classTalk") {
        if (action === "chat_FileTransfer") {
            const { uploadedPath, fileTransferType = "file-transfer", isAutoDownloadAllowed, isOverwriteAllowed = false, executeYn, userNickname: infoUserNickname, originalFileName, contentSeq } = information;
            const finalIsAutoDownloadAllowed = executeYn === "Y" ? true : isAutoDownloadAllowed;

            _rcvChatFileShareHelper(
                uploadedPath,
                infoUserNickname || userNickname,
                routingKey,
                fileTransferType,
                finalIsAutoDownloadAllowed,
                originalFileName,
                contentSeq,
                isOverwriteAllowed
            );
        } else {
            console.log("rcvJsonDataHelper - action is else... ", action);
            sendToBrowserData("sendJson", JSON.stringify(dataObject), "");
        }
    } else if (kind === "intensiveControl" || kind === "whisper-intensiveControl") {
        rcvIntensiveControlHelper(dataObject, userNickname, routingKey);
    } else if (kind === "sendToWifiHandup") {
        // 20260720 추가: Pentalk Pro(ProPBL2604MQTT)의 PBL 제어 메뉴([컨텐츠목록]/[사용자목록]/[모둠판서]와
        // 20260720 신규 추가된 [선생님 화면 보기/닫기]/[컨텐츠 목록 비우기]/[저장된 파일 모두 삭제])에서 보낸
        // {kind:"sendToWifiHandup", action:"PBL_Action", information:{kind:"mode_select", selectMode:"..."}} 형태의
        // 메시지를 Pentalk WiFi(WinPBLGroup2606_260630)로 그대로 전달한다.
        // selectMode 값: "userList"/"ContentList"/"Lecture_mode"(기존) ,
        //               "TeacherScreenShow"/"TeacherScreenHide"/"ContentListClear"/"AllFilesClear"(신규)
        console.log(`rcvJsonDataHelper - kind[${kind}] action[${action}] information => `, information);
        sendToBrowserData("sendJson", JSON.stringify(dataObject), "");
    } else if (kind === "remoteControl") {
        // 20260713 ... pbl 모드 브라우저(Pentalk WiFi)에서도 원격 제어(remoteControl) 데이터를 받을 수 있도록 처리 ... by ri
        console.log(`rcvJsonDataHelper - kind[${kind}] action[${action}] information => `, information);

        if (
            action === "start" ||
            action === "end" ||
            action === "positionInfo" ||
            action === "keyInfo" ||
            action === "penstart" ||
            action === "penend"
        ) {
            // rcvMsgFromRbmq.js의 remoteControl 처리(action별 android/windows webview 분기)와 동일한 action을
            // Pentalk WiFi 쪽(eoapi)으로 그대로 전달함 ... by ri
            sendToBrowserData("sendRemoteControlData", JSON.stringify({ event: action, data: information }), "");
        } else {
            console.log("rcvJsonDataHelper - remoteControl action is else... ", action);
        }
    } else {
        sendToBrowserData("sendJson", JSON.stringify(dataObject), "");
    }
}

/**
 * Pentalk Pro에서 받은 RBMQ 메시지 데이터를
 * Pentalk WiFi에 전달해야 하는 경우
 * C#의 eoapi를 통해 전달하도록 돕는 Helper 메서드
 * 
 * @param {String} func - 메서드 명
 * @param {String} data1 - 전달할 데이터 1
 * @param {String} data2 - 전달할 데이터 2
 * @since 2025-07-14.
 */
const sendToBrowserData = (func, data1, data2) => {
    if (window.eoapi !== undefined && window.eoapi !== null) {
        window.eoapi.extInvoke(func, [data1, data2]);
    }
}
